// Debug configuration
export const DebugConfig = {
  // Set to true to use fixtures instead of real API calls
  useFixtures: process.env.REACT_APP_USE_FIXTURES === 'true',
  
  // Set to true to enable detailed logging
  enableLogging: process.env.NODE_ENV === 'development',
  
  // Set to true to enable Redux DevTools
  enableReduxDevTools: process.env.NODE_ENV === 'development',
  
  // API base URL - supports environment variables
  apiBaseURL: process.env.REACT_APP_API_URL, // "https://cdc.digitalnovacore.com/api",
  
  // Mock delay for fixture responses (in milliseconds)
  fixtureDelay: 500,
};
